var _defs, _path, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMmcPhoneAppTheGramDm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13.9 12.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #3c3c3b;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M5.16,12.01c-.05,0-.11,0-.16-.03-.2-.07-.34-.26-.34-.47V4.71S.17,.88,.17,.88C.02,.74-.04,.52,.03,.33c.07-.2,.26-.33,.47-.33H13.4c.19,0,.36,.11,.45,.28s.07,.37-.05,.52L5.56,11.81c-.1,.13-.25,.2-.4,.2ZM1.85,1l3.62,3.1c.11,.09,.17,.23,.17,.38v5.53S12.4,1,12.4,1H1.85Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4.7,
    y: 1.99,
    width: 9.16,
    height: 1,
    transform: "translate(-.16 4.28) rotate(-25.76)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMmcPhoneAppTheGramDm);
export default __webpack_public_path__ + "static/media/MMC_Phone App_TheGram_DM.7a97591e15754b0b0dcd189b0c5b11bb.svg";
export { ForwardRef as ReactComponent };